
<template>
  <div class="question">
    <a-spin class="load" v-show="loading" />
    <div class="top">
        <span class="icon" @click="goHistory"><img class="goHistory" src="../../assets/image/08.png" alt=""></span>
        <span class="iconText">问题归类-查看问题</span>
    </div>
    <div class="content">
      <div class="contMes">
        <div class="mesList">
          <a-list item-layout="vertical" size="large"  :data-source="listDataDetail">
            <a-list-item slot="renderItem" key="item.title" slot-scope="item">
            <a-list-item-meta :description="item.description">
                <div slot="title">
                  <div class="prepare">
                      <div class="bookName">{{item.lessonTitle}}</div>
                      <!-- <p class="bookTitle">{{item.textContent}}</p> -->
                      <a-row style="height:300px;overflow:hidden;">
                        <a-col :span="1">
                          <img class="photoImg" :src="$userINfoBasePath+'/'+item.userphoto" alt="" />
                        </a-col>
                        <a-col :span="23">
                          <!-- <span class="userName">{{item.userName}}</span><span class="userSchool">{{item.userClassInfo}}</span> -->
                          <p class="questionText">{{item.askContent}}</p>
                          <p class="date">{{format.formatDayTime(item.createDate)}}</p>
                          <div v-for="(d, index) in item.askReplys" :key="index">
                            <span class="userName">{{d.userName}}</span>  <span class="fuhao">@</span><span class="userSchool">{{d.recuserName}}</span>
                            <p class="questionText">{{d.replyContent}}</p>
                            <p class="date">{{format.formatDayTime(d.createDate)}}</p>
                          </div>
                        </a-col>
                      </a-row>
                  </div>
                </div>
            </a-list-item-meta>
            </a-list-item>
          </a-list>
        </div>
      <div style="text-align:center;margin-top:10px;">
        <a-config-provider>
          <a-pagination :default-current="1"
            :page-size="pageSize"
            @change="handleListChange"
            :total='total'
          />
        </a-config-provider>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import format from '../../utils/format.js'
export default {
  name: 'ClassifyQuestionDetail',
  data () {
    return {
      format,
      resBasePath: this.$resBasePath,
      loading: false,
      listDataDetail: [],
      total: 0,
      pageSize: 5,
      pageNum: 1,
      id: ''
    }
  },
  methods: {
    goHistory () { // 返回上一级
      this.$router.go(-1)
    },
    searchQuestion () {
      let _this = this
      const param ={
        pageSize: _this.pageSize,
        pageNum: _this.pageNum,
        id: _this.id
      }
      this.$fetch({
        url: _this.$baseUrl + 'ebook/comment/getReplyByAskId',
        body:{id:_this.id}
      }).done(res => {
        if(res && res.success && res.resultCode === 0){
          _this.loading = false
          _this.listDataDetail = res.resultData
          if(_this.listDataDetail.length<1){
            _this.listDataDetail = [
              {
              "id": "17",
              "userId": "a01bbeeec1904e1889fe83885c17ce61",
              "name": null,
              "lang": "en",
              "accessToken": null,
              "clientId": null,
              "bookId": "1",
              "styleId": "38",
              "lessonTitle": "荷塘月色",
              "paragraphId": "732096006",
              "sentenceId": null,
              "objectType": null,
              "userName": "山东学生一",
              "askContent": "这篇课文想表达什么？",
              "isReply": 1,
              "isUrgent": 1,
              "isUnderstand": 0,
              "askType": null,
              "activityId": null,
              "askPermission": 2,
              "praiseNumber": 0,
              "userphoto": null,
              "userClassInfo": null,
              "createDate": 1592372854000,
              "updateDate": 1592679148000,
              "isr": 0,
              "position": null,
              "replyCount": 0,
              "isPraise": null,
              "textContent": "故都的秋",
              "askReplys": [//回复列表
              {
              "id": "3",
              "userId": "30c682712bdf475f9f8e03f180c530af",
              "name": null,
              "lang": "en",
              "accessToken": null,
              "clientId": null,
              "rootId": "17",
              "parentId": "17",
              "bookId": "1",
              "styleId": "38",
              "paragraphId": null,
              "sentenceId": null,
              "userName": "山东教师1",
              "recuserId": "a01bbeeec1904e1889fe83885c17ce61",
              "recuserName": "山东学生一",
              "askId": null,
              "replyType": 3,
              "replyContent": "bbb",
              "praiseNumber": 0,
              "isPraise": null,
              "activityId": null,
              "userphoto": null,
              "userClassInfo": null,
              "recuserPhoto": null,
              "recuserClassInfo": null,
              "createDate": 1592378798000,
              "updateDate": 1592378801000
              },
              ]},
              {
              "id": "17",
              "userId": "a01bbeeec1904e1889fe83885c17ce61",
              "name": null,
              "lang": "en",
              "accessToken": null,
              "clientId": null,
              "bookId": "1",
              "styleId": "38",
              "lessonTitle": "荷塘月色",
              "paragraphId": "732096006",
              "sentenceId": null,
              "objectType": null,
              "userName": "山东学生一",
              "askContent": "这篇课文想表达什么？",
              "isReply": 1,
              "isUrgent": 1,
              "isUnderstand": 0,
              "askType": null,
              "activityId": null,
              "askPermission": 2,
              "praiseNumber": 0,
              "userphoto": null,
              "userClassInfo": null,
              "createDate": 1592372854000,
              "updateDate": 1592679148000,
              "isr": 0,
              "position": null,
              "replyCount": 0,
              "isPraise": null,
              "textContent": "故都的秋",
              "askReplys": [//回复列表
              {
              "id": "3",
              "userId": "30c682712bdf475f9f8e03f180c530af",
              "name": null,
              "lang": "en",
              "accessToken": null,
              "clientId": null,
              "rootId": "17",
              "parentId": "17",
              "bookId": "1",
              "styleId": "38",
              "paragraphId": null,
              "sentenceId": null,
              "userName": "山东教师1",
              "recuserId": "a01bbeeec1904e1889fe83885c17ce61",
              "recuserName": "山东学生一",
              "askId": null,
              "replyType": 3,
              "replyContent": "bbb",
              "praiseNumber": 0,
              "isPraise": null,
              "activityId": null,
              "userphoto": null,
              "userClassInfo": null,
              "recuserPhoto": null,
              "recuserClassInfo": null,
              "createDate": 1592378798000,
              "updateDate": 1592378801000
              },
              ]}
            ]
            this.total = this.listDataDetail.length
          }
        }
      })
    },
    handleListChange(current, pageSize) {
      this.checkAll = false
      this.pageNum = current
      this.pageSize = pageSize
      this.searchQuestion()
    },
  },
  mounted () {
    this.id = this.$route.params.id
    console.log(this.id)
    this.searchQuestion()
  }
}
</script>
<style lang="less" scoped>
ul,li,p{
  margin: 0;
  padding: 0;
  list-style: none;
}
  .question{
    position: relative;
    .load{
      position:absolute;
      top: 40%;
      left: 50%;
      transform: translate(50%,50%);
    }
    .top{
        height: 110px;
        background-color: #fff;
        position: relative;
        padding: 0 50px;
        .goHistory{
            width: 16px;
            height: 32px;
            cursor: pointer;
        }
        .icon{
            position: absolute;
            top: 50%;
            margin-top: -7px;
            left: 50px;
        }
        .iconText{
            position: absolute;
            top: 50%;
            margin-top: -10px;
            left: 100px;
            color: #9d9292;
            font-size: 24px;
        }
        .button{
          position: absolute;
          width: 180px;
          height: 45px;
          background-color: #e8f8f3;
          text-align: center;
          line-height: 44px;
          font-family: PingFangSC-Semibold;
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #22c190;
          top: 50%;
          right: 50px;
          margin-top: -20px;
          cursor: pointer;
        }
    }
    .content{
      width: 100%;
      background: #f6f6f6;
      padding-top:30px;
      .contMes{
        width: 1240px;
        background: #fff;
        margin: 0 auto;
        padding:20px 50px;
        .questionSolve{
          text-align: right;
          width: 120px;
          height: 32px;
          background-image: linear-gradient(122deg,
            #ff8d46 0%,
            #fa5542 100%);
          box-shadow: 0px 2px 8px 0px
            #dbcebc;
          border-radius: 16px;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 32px;
          letter-spacing: 0px;
          color: #ffffff;
          text-align: center;
          cursor: pointer;
          margin-left: auto;
        }
      }
      .mesList{
        width: 1140px;
        margin: 0 auto;
        background: #fff;
        margin-top: 20px;
      }
    }
  }
    .prepare{
      padding: 20px;
      background: #f6f6f6;
      margin-top: 20px;
    .bookName{
      font-family: PingFangSC-Regular;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 22px;
      letter-spacing: 0px;
      color: #9d9292;
    }
    .bookTitle{
      font-family: PingFangSC-Regular;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 26px;
      letter-spacing: 0px;
      color: #9d9292;
      margin: 10px 0px;
    }
    .photoImg{
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
    .userName{
      font-size: 18px;
      color: #000;
      line-height: 26px;
    }
    .fuhao{
      font-size: 18px;
      color: #9d9292;
      margin-left:0px;
      line-height: 26px;
    }
    .userSchool{
      font-size: 18px;
      color: #9d9292;
      margin-left:10px;
      line-height: 26px;
    }
    .questionText{
      font-size: 20px;
      line-height: 30px;
      color: #040506;
    }
    .date{
      color: #9d9292;
      font-size: 14px;
    }
    .forAsk{
      text-align: right;
      height: 30px;
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 30px;
      letter-spacing: 0px;
      color: @primary-color;
      cursor: pointer;
    }
    }
    .ulList{
      margin-top: 10px;
      .listMes{
          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #9d9292;
          height: 30px;
          line-height: 30px;
      }
  }
  .askHelp{
    height: 60px;
    width: 100%;
    background: #fff;
    .ask{
        width: 120px;
        height: 32px;
        background-color: @primary-color;
        border-radius: 4px;
        color: #ffffff;
        font-size: 16px;
        float: right;
        margin-top: 14px;
    }
    .help{
      width: 120px;
      height: 32px;
      background-color: #a3af90;
      border-radius: 4px;
      color: #ffffff;
      font-size: 16px;
      float: right;
      margin-left: 20px;
      margin-top: 14px;
    }
  }
  .mesMore{
    min-height: 160px;
    padding: 20px;
    background: #f6f6f6;
  }
  .footer{
    height:50px;
    line-height:50px;
    text-align: right;
  }
  .answerMes{
    .answerText{
      font-size: 16px;
      color: #9d9292;
    }
    .answerName{
      color: @primary-color;
      font-size: 18px;
      margin-left: 20px;
    }
    .answerTitle{
      font-family: PingFangSC-Regular;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 22px;
      letter-spacing: 0px;
      color: #000000;
      margin-top: 10px;
    }
    .answerBgc{
      margin-top: 10px;
      background-color: #f6f6f6;
    }
    /deep/.ant-input{
      background-color: #f6f6f6;
    }
  }
  .zjcontent{
    padding: 20px;
    .title{
      height: 50px;
      font-family: PingFangSC-Semibold;
      font-size: 36px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 50px;
      letter-spacing: 0px;
      color: #db5647;
      text-align: center;
    }
    .proplem{
      font-family: PingFangSC-Regular;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 46px;
      letter-spacing: 0px;
      color: #040506;
      text-align: center;
      .name{
        font-family: PingFangSC-Semibold;
        font-size: 24px;
        font-weight: normal;
        letter-spacing: 0px;
        color: @primary-color;
      }
    }
    .zjFooter{
      text-align: center;
      margin-top: 10px;
      .cancle{
        width: 160px;
        height: 30px;
        background: #f6f6f6;
        color: #9d9292;
        font-size: 18px;
      }
      .sure{
        width: 160px;
        height: 30px;
        background: #f6f6f6;
        background-color: @primary-color;
        font-size: 18px;
        color:#fff;
        margin-left: 30px;
      }
    }
  }
  /deep/.ant-modal-header{
    border-bottom: none;
  }
  /deep/.ant-modal-title{
    font-size: 24px;
    color: #000000;
  }
/deep/.ant-list-pagination{
  text-align: center;
  margin-top: 0px;
  background: #fff;
}
/deep/.ant-list-vertical .ant-list-item-meta{
    margin-bottom: 0px;
}
/deep/.ant-list-split .ant-list-item{
    border-bottom: none;
}
/deep/.ant-list-something-after-last-item .ant-spin-container > .ant-list-items > .ant-list-item:last-child{
  border-bottom: none;
}
/deep/.ant-list-lg .ant-list-item{
  padding: 0px;
}
/deep/.ant-list-vertical .ant-list-item-meta-title{
  margin-bottom: 0px;
}
</style>
